/**
 * @prettier
 */
import { useParams as _useParams } from 'react-router-dom';

export const useParams: <T extends any>() => T = _useParams as any;
